// extracted by mini-css-extract-plugin
export var alpha = "_kd-4";
export var alphaInputContainer = "_kd-j";
export var badge = "_kd-b";
export var brandKitGrid = "_kd-l";
export var brandKitItem = "_kd-m";
export var brandKitSwatch = "_kd-n";
export var controls = "_kd-5";
export var formatDropdown = "_kd-h";
export var formatSelector = "_kd-g";
export var hex = "_kd-6";
export var hexInput = "_kd-i";
export var hue = "_kd-3";
export var hueAndAlphaPointer = "_kd-a";
export var percentageLabel = "_kd-k";
export var picker = "_kd-0";
export var rgba = "_kd-8";
export var rgbaSection = "_kd-7";
export var saturation = "_kd-1";
export var saturationPointer = "_kd-9";
export var sliders = "_kd-2";
export var swatch = "_kd-c";
export var swatchDisabled = "_kd-f";
export var swatchRing = "_kd-d";
export var swatchTransparent = "_kd-e";